const ROW_SELECT_COLUMN_WIDTH = '2%';

export { ROW_SELECT_COLUMN_WIDTH };
